"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/material/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _excluded = ["children", "title", "contentStyle", "titleStyle"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PREFIX = 'Section';
var classes = {
  paper: "".concat(PREFIX, "-paper"),
  titleContainer: "".concat(PREFIX, "-titleContainer")
};
var StyledBox = (0, _styles.styled)(_material.Box)(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    boxShadow: 'rgb(60, 64, 67, 10%) 0px 1px 3px 0px, rgb(60, 64, 67, 1%) 0px 2px 1px 2px',
    height: '100%',
    borderRadius: '4px'
  }, _defineProperty(_ref2, "& .".concat(classes.paper), _defineProperty({
    background: theme.palette.content.primary,
    fontWeight: 400,
    color: theme.palette.font.primary,
    padding: '22px'
  }, theme.breakpoints.down('sm'), {
    padding: '20px 12px'
  })), _defineProperty(_ref2, "& .".concat(classes.titleContainer), _defineProperty({
    background: theme.palette.title.background,
    color: '#709baf'
  }, theme.breakpoints.down('sm'), {
    padding: '20px 18px'
  })), _ref2;
});
var StyledDialogContent = (0, _styles.styled)(_material.DialogContent)(function () {
  return {
    borderBottomRightRadius: '4px',
    borderBottomLeftRadius: '4px',
    height: 'calc(100% - 78px)'
  };
});
var StyledDialogTitle = (0, _styles.styled)(_material.DialogTitle)(function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    height: '78px',
    borderTopRightRadius: '4px',
    borderTopLeftRadius: '4px'
  }, theme.breakpoints.down('sm'), {
    height: 'auto'
  });
});

function Section(_ref5) {
  var children = _ref5.children,
      title = _ref5.title,
      contentStyle = _ref5.contentStyle,
      titleStyle = _ref5.titleStyle,
      props = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/_react.default.createElement(StyledBox, props, /*#__PURE__*/_react.default.createElement(StyledDialogTitle, {
    className: classes.titleContainer,
    sx: titleStyle
  }, title), /*#__PURE__*/_react.default.createElement(StyledDialogContent, {
    dividers: true,
    className: classes.paper,
    sx: contentStyle
  }, children));
}

Section.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]).isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.string.isRequired, _propTypes.default.object.isRequired]).isRequired,
  contentStyle: _propTypes.default.object
};
var _default = Section;
exports.default = _default;